document.querySelectorAll('[data-pdp-preorder]').forEach(function (band) {
  var heroForm = document.querySelector('[data-pdp-form]');
  var heroAtc = document.querySelector('[data-pdp-atc]');
  var heroPackInputs = document.querySelectorAll('[data-pdp-pack-input]');
  if (!heroForm || !heroAtc) return;

  function formatMoney(cents) {
    return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
  }

  var currentPriceEl = band.querySelector('[data-pdp-preorder-current-price]');
  var comparePriceEl = band.querySelector('[data-pdp-preorder-compare-price]');
  var priceWrap = band.querySelector('[data-pdp-preorder-price]');

  function setPrice(price, comparePrice) {
    if (currentPriceEl) currentPriceEl.textContent = formatMoney(price);
    if (!priceWrap) return;
    if (comparePrice > price) {
      if (!comparePriceEl) {
        comparePriceEl = document.createElement('s');
        comparePriceEl.className = 'pdp-preorder__price-compare';
        comparePriceEl.setAttribute('data-pdp-preorder-compare-price', '');
        priceWrap.insertBefore(comparePriceEl, priceWrap.firstChild);
      }
      comparePriceEl.textContent = formatMoney(comparePrice);
      comparePriceEl.hidden = false;
    } else if (comparePriceEl) {
      comparePriceEl.hidden = true;
    }
  }

  function setActive(input) {
    band.querySelectorAll('.pdp-preorder__pack-pill').forEach(function (pill) { pill.classList.remove('is-active'); });
    input.closest('.pdp-preorder__pack-pill').classList.add('is-active');
  }

  band.querySelectorAll('[data-pdp-preorder-pack-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      setActive(input);
      setPrice(input.dataset.price, input.dataset.comparePrice);
      var match = Array.prototype.filter.call(heroPackInputs, function (heroInput) {
        return heroInput.value === input.value;
      })[0];
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  heroPackInputs.forEach(function (heroInput) {
    heroInput.addEventListener('change', function () {
      var match = band.querySelector('[data-pdp-preorder-pack-input][value="' + heroInput.value + '"]');
      if (match && !match.checked) {
        match.checked = true;
        setActive(match);
        setPrice(heroInput.dataset.price, heroInput.dataset.comparePrice);
      }
    });
  });

  var cta = band.querySelector('[data-pdp-preorder-atc]');
  if (cta) {
    cta.addEventListener('click', function () {
      if (typeof heroForm.requestSubmit === 'function') {
        heroForm.requestSubmit(heroAtc);
      } else {
        heroAtc.click();
      }
    });
  }
});
